import { useEffect, useState } from 'react';
import { mockTestimonials } from '../data/mock';
import { BACKEND_URL } from '../config/brand';

const mapApiTestimonial = (t) => ({
  id: t.id,
  name: t.name,
  role: t.role,
  content: t.content,
  rating: t.rating || 5,
  avatar: t.image_url || t.avatar,
});

/**
 * Charge les avis publics depuis l'API, avec fallback mock.
 * @param {number} [limit] — nombre max d'avis à retourner
 */
export function useTestimonials(limit) {
  const [testimonials, setTestimonials] = useState(() =>
    typeof limit === 'number' ? mockTestimonials.slice(0, limit) : mockTestimonials
  );

  useEffect(() => {
    if (!BACKEND_URL) return;
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/testimonials`);
        if (!res.ok) return;
        const data = await res.json();
        if (!Array.isArray(data) || data.length === 0 || cancelled) return;
        const mapped = data.map(mapApiTestimonial);
        setTestimonials(typeof limit === 'number' ? mapped.slice(0, limit) : mapped);
      } catch {
        // fallback mock
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [limit]);

  return testimonials;
}

export default useTestimonials;
